import ErrorPage from '@clarity-website/common/ErrorPage';

export default function PageNotFound() {
  return (
    <ErrorPage description="We couldn't find the page you were looking for!" />
  );
}
